import { client } from "api";

export type SetTimeEntryApprovalRequest = {
  absenceId: string;
  state: "APPROVED" | "REJECTED";
  message?: string;
};

export type SetTimeEntryApprovalResponse = string;

export const setTimeEntryApproval = (
  request: SetTimeEntryApprovalRequest
): Promise<SetTimeEntryApprovalResponse> =>
  client
    .post<SetTimeEntryApprovalResponse>("/absence/adminSetStatus", request)
    .then((res) => res.data);
